import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import videoData from "./videos.json";
import UserSideBar from "./userSideBar";
import "./Movies.css";

const Movies = () => {
  const [selectedVideo, setSelectedVideo] = useState(videoData[0]);
  const [showSummary, setShowSummary] = useState(false);
  const navigate = useNavigate();
    const [username, setUsername] = useState("");
  
      useEffect(() => {
          const params = new URLSearchParams(window.location.search);
          const accessToken = params.get("token");
          const usernameParam = params.get("username");
  
          if (accessToken) {
              localStorage.setItem("access_token", accessToken);
              if (usernameParam) {
                  localStorage.setItem("username", usernameParam);
                  setUsername(usernameParam);
              }
              // Remove token from URL
              window.history.replaceState({}, document.title, "/user");
          } 
          // Else if we don't have a token stored, redirect to login
          else if (!localStorage.getItem("access_token")) {
              alert("You are not logged in. Redirecting to login...");
              navigate("/");
          } 
          // Otherwise, fetch the username from localStorage
          else {
              setUsername(localStorage.getItem("username") || "User");
          }
      }, [navigate]);

  // Handler to change the currently selected video
  const handleVideoSelect = (video) => {
    setSelectedVideo(video);
    setShowSummary(false); // Hide summary when switching videos
  };

  const toggleSummary = () => {
    setShowSummary((prev) => !prev);
  };

  return (
    <div className="movies-container">
      {/* Left side user sidebar */}
      <UserSideBar />

      {/* Player container */}
      <div className="player-container">
        <h1 className="page-title">Movie Sharing - {selectedVideo.title}</h1>
        <div className="iframe-wrapper">
          <iframe
            title={selectedVideo.title}
            src={`https://drive.google.com/file/d/${selectedVideo.fileId}/preview`}
            allowFullScreen
            className="video-iframe"
          />
        </div>

        {/* Introduction in a card */}
        {selectedVideo.introduction && (
          <div className="intro-card">
            <h3 className="intro-title">
              Introduction – {selectedVideo.title}
            </h3>
            <p className="intro-text">{selectedVideo.introduction}</p>
          </div>
        )}

        {/* Button to toggle summary */}
        {selectedVideo.summary && (
          <button className="summary-btn" onClick={toggleSummary}>
            {showSummary ? "Hide Summary" : "View Summary"}
          </button>
        )}

        {/* Summary (conditionally shown) */}
        {showSummary && selectedVideo.summary && (
          <div className="movie-summary">
            <p>{selectedVideo.summary}</p>
          </div>
        )}
      </div>

      {/* Right side: Video List */}
      <div className="Vsidebar">
        <h2 className="Vsidebar-title">Available Videos</h2>
        <ul className="video-list">
          {videoData.map((video) => (
            <li
              key={video.fileId}
              className={`video-list-item ${
                video.fileId === selectedVideo.fileId ? "active" : ""
              }`}
              onClick={() => handleVideoSelect(video)}
            >
              {video.title}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Movies;
